import filter from 'lodash/filter';
import head from 'lodash/head';

export class MissionHistoryService {
	constructor($resource, ApiService) {
		'ngInject';

		this.$resource = $resource;
		this.apiService = ApiService;

		this.missionHistoryResourceUrl = this.apiService.getResourceUrl('menus/MissionHistory');

		this.missionHistoryResource = this.$resource(this.missionHistoryResourceUrl);
	}

	_getOverviewDetailsObject(details) {
		return {
			contentId: details.content_id,
			menuId: details.menu_id,
			displayName: details.display_name,
			name: details.name,
			title: details.title,
			description: details.description
		}
	}

	_getContentObject(values) {
		let details = filter(values, ['name', 'MissionHistory']);
		return _getContentData(head(details).values);

		function _getContentData(data) {
			return data.map(({title, description}) => ({title, description}))
		}		
	}

	getMissionHistoryDetails(details) {
		return {
			menuOverviewDetails: this._getOverviewDetailsObject(details.data.menuOverviewDetails),
			details: this._getContentObject(details.data.content)
		};
	}
}


// WEBPACK FOOTER //
// ./src/app/components/about-us-mission-history/about-us-mission-history.service.js